module.exports = __webpack_public_path__ + "img/co2_gray.b4949d59.svg";